import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import AssistantFab from "./AssistantFab";

const titleByPath: Record<string, string> = {
  "/overview": "Overview",
  "/reports": "Reports",
  "/alerts": "Alerts",
  "/settings": "Settings",
};

export default function AppShell() {
  const loc = useLocation();
  const rootPath = "/" + (loc.pathname.split("/")[1] ?? "");
  const title = titleByPath[rootPath] ?? "Daybrief";

  return (
    <div className="flex min-h-screen max-w-[1600px] mx-auto bg-bg-app shadow-shell">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <TopBar title={title} />
        <div className="flex-1 px-7 py-7">
          <Outlet />
        </div>
      </main>
      <AssistantFab contextLabel="current view" />
    </div>
  );
}
